import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    responsables: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_RESPONSABLES = 'GET_ALL_RESPONSABLES'
const GET_RESPONSABLES_BY_ID = 'GET_RESPONSABLES_BY_ID'
const POST_RESPONSABLES = 'POST_RESPONSABLES'
const POST_RESPONSABLES_INE = 'POST_RESPONSABLES_INE'
const UPDATE_RESPONSABLES = 'UPDATE_RESPONSABLES'
const DELETE_RESPONSABLES = 'DELETE_RESPONSABLES'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllResponsables = createAsyncThunk(
    GET_ALL_RESPONSABLES,
    async () => {
        try {
            const fullUrl = host + `Fi25Responsables/obtenerResponsables`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Vehiculos: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getResponsablesById = createAsyncThunk(
    GET_RESPONSABLES_BY_ID,
    async (idResponsable) => {
        try {
            const fullUrl = host + `Fi25Responsables/obtenerResponsableById/${idResponsable}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertResponsablesIne = createAsyncThunk(
    POST_RESPONSABLES_INE,
    async (data) => {
        try {
            const fullUrl = host + `Fi25Responsables/agregarResponsableConIne`
            const fullUrl2 = host + `Fi25Responsables/agregarResponsable`
            //alert(JSON.stringify(data))
            const datamain = { data: data.data }
            const imagen = data.imagen
            const imagen2 = data.imagen2
            if (imagen != undefined && imagen2 != undefined) {
                let formData = new FormData();
                formData.append(0, imagen)
                formData.append(1, imagen2)
                formData.append('idfi_25caratula', datamain.data.idfi_25caratula)
                formData.append('nombre', datamain.data.nombre)
                formData.append('edad', datamain.data.edad)
                formData.append('telefono', datamain.data.telefono)
                formData.append('correoelectronico', datamain.data.correoelectronico)
                formData.append('validado', datamain.data.validado)
                const resFile = await axios.post(fullUrl, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            } else {
                const resFile = await axios.post(fullUrl2, datamain)
            }
            return 'result'
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertResponsables = createAsyncThunk(
    POST_RESPONSABLES,
    async (data) => {
        try {
            const fullUrl = host + `Fi25Responsables/agregarResponsable`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateResponsables = createAsyncThunk(
    UPDATE_RESPONSABLES,
    async (data) => {
        try {
            const fullUrl = host + `Fi25Responsables/actualizarResponsable`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteResponsables = createAsyncThunk(
    DELETE_RESPONSABLES,
    async (idResponsable) => {
        try {
            const fullUrl = host + `Fi25Responsables/eliminarResponsable/${idResponsable}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosResponsablesSlice = createSlice({

    name: 'metodosResponsablesSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllResponsables.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.responsables = payload.data.data

        },
        [getResponsablesById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.responsables = payload.data.data
        },
        [insertResponsables.fulfilled]: (state, { payload }) => {

        },
        [insertResponsablesIne.fulfilled]: (state, { payload }) => {

        },
        [updateResponsables.fulfilled]: (state, { payload }) => {

        },
        [deleteResponsables.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosResponsablesSlice.actions
export const ResponsablesReducer = metodosResponsablesSlice.reducer